import Vue from "vue";
import Vuex from "vuex";
import { RootState } from "./types";
import { authentication } from "./authentication/index";
import mutations from "./mutations";
import getters from "./getters";
import actions from "./actions";
import VuexPersistence from "vuex-persist";

Vue.use(Vuex);

const persistAuthentication = new VuexPersistence<RootState>({
    key: "authentication",
    storage: window.localStorage,
    modules: ["authentication"]
});

export default new Vuex.Store<RootState>({
    state: {
        reload: 1
    },
    modules: {
        authentication
    },
    mutations,
    actions,
    getters,
    plugins: [persistAuthentication.plugin]
});
